// External libraries
import styled from '@emotion/styled';

/* eslint-disable max-len */
const ShieldValuePropImg = styled.div`
  background-image: url(https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png);
  background-position: center 0;
  background-repeat: no-repeat;
  height: 92px;
  @media only screen and (-webkit-min-device-pixel-ratio: 2),
    only screen and (-o-min-device-pixel-ratio: 2/1),
    only screen and (min-resolution: 192dpi),
    only screen and (min-resolution: 2dppx) {
    background-image: url(https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png);
    background-size: 206px 92px;
  }
`;
/* eslint-enable max-len */

const ValuePropContainer = styled.div`
  display: none;
  @media (min-width: 699px) {
    display: block;
    margin: 70px 0 0 32px;
    text-align: center;
    width: 36%;
  }
`;

const MerchantLogoContainer = styled.div`
  display: none;
  @media (min-width: 699px) {
    display: block;
    flex: 0 0 100%;
    line-height: 1.2;
    margin-bottom: 2px;
    overflow: hidden;
    z-index: 1;
  }
`;

const MerchantLogo = styled.img`
  height: auto;
  max-height: 90px;
  max-width: 780px;
  vertical-align: middle;
  width: auto;
`;

export {
  MerchantLogoContainer,
  MerchantLogo,
  ShieldValuePropImg,
  ValuePropContainer,
};
